export function formatLocalDate(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function zipDownloadName(date) {
  return `etiquetas_${date}.zip`;
}

export function unifiedPdfName(paper, date) {
  return `${paper}_${date}.pdf`;
}

export function pagePdfPath(paper, pageNumber, date) {
  const nn = String(pageNumber).padStart(2, "0");
  return `${paper}/${paper}_pagina-${nn}_${date}.pdf`;
}
